"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _UIHelpIcon = _interopRequireDefault(require("../icon/UIHelpIcon"));

var _UIOverlay = _interopRequireDefault(require("../overlay/UIOverlay"));

var _InputConstants = require("../input/InputConstants");

var _FieldsetContext = require("../context/FieldsetContext");

var CustomRenderer = _interopRequireWildcard(require("../utils/propTypes/customRenderer"));

var _decorators = require("../utils/propTypes/decorators");

var _UIFormControl = _interopRequireDefault(require("./UIFormControl"));

var _memoizeOne = _interopRequireDefault(require("react-utils/memoizeOne"));

var _sizes = require("HubStyleTokens/sizes");

var _colors = require("HubStyleTokens/colors");

var _component = _interopRequireDefault(require("../utils/propTypes/component"));

function _templateObject5() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n      ::after {\n        content: ' *';\n      }\n    "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  padding-right: 0;\n\n  ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  color: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  padding: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  position: relative;\n  min-width: 0;\n  margin: 0;\n  padding: 0;\n  border: 0;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

/**
 * Note: This is the standards-recommmended markup pattern, but some AT, like
 * VoiceOver doesn't yet read the legend as the label for the nested controls.
 * Link: https://www.powermapper.com/tests/screen-readers/labelling/fieldset-with-yes-no-radio-buttons/
 **/
var Outer = _styledComponents.default.fieldset.withConfig({
  displayName: "UIFieldset__Outer",
  componentId: "sc-2052zb-0"
})(_templateObject());

var LabelWrapper = _styledComponents.default.div.withConfig({
  displayName: "UIFieldset__LabelWrapper",
  componentId: "sc-2052zb-1"
})(_templateObject2(), function (_ref) {
  var hasLegend = _ref.hasLegend;
  return hasLegend && _sizes.LABEL_DEFAULT_PADDING_TOP + " 0 " + _sizes.LABEL_DEFAULT_PADDING_BOTTOM;
});

var HelpText = _styledComponents.default.span.withConfig({
  displayName: "UIFieldset__HelpText",
  componentId: "sc-2052zb-2"
})(_templateObject3(), _colors.EERIE);

var FieldsetLegend = (0, _styledComponents.default)(function (props) {
  var children = props.children,
      className = props.className,
      id = props.id;
  return _react.default.createElement("span", null, _react.default.createElement("legend", {
    id: id,
    className: "sr-only"
  }, children), _react.default.createElement("span", {
    "aria-hidden": true,
    className: className
  }, children));
}).withConfig({
  displayName: "UIFieldset__FieldsetLegend",
  componentId: "sc-2052zb-3"
})(_templateObject4(), function (props) {
  return props.required && (0, _styledComponents.css)(_templateObject5());
});

var getContext = function getContext(disabled, size) {
  return {
    disabled: disabled,
    size: size
  };
};

var UIFieldset =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(UIFieldset, _PureComponent);

  function UIFieldset(props) {
    var _this;

    (0, _classCallCheck2.default)(this, UIFieldset);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UIFieldset).call(this, props));
    _this._getContext = (0, _memoizeOne.default)(getContext);
    return _this;
  }

  (0, _createClass2.default)(UIFieldset, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          disabled = _this$props.disabled,
          Legend = _this$props.Legend,
          legend = _this$props.legend,
          legendId = _this$props.legendId,
          overlay = _this$props.overlay,
          _size = _this$props._size,
          _required = _this$props._required,
          help = _this$props.help,
          tooltip = _this$props.tooltip,
          tooltipPlacement = _this$props.tooltipPlacement,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["children", "disabled", "Legend", "legend", "legendId", "overlay", "_size", "_required", "help", "tooltip", "tooltipPlacement"]);
      var hasOverlay = !!overlay;
      var computedDisabled = hasOverlay ? true : disabled;
      var renderedLegend = legend ? _react.default.createElement(Legend, {
        id: legendId,
        required: _required
      }, legend) : null;
      var renderedLegendWithTooltip = tooltip ? _react.default.createElement(_UIHelpIcon.default, {
        title: tooltip,
        tooltipPlacement: tooltipPlacement
      }, renderedLegend) : renderedLegend;
      var renderedOverlay = null;

      if (overlay) {
        renderedOverlay = CustomRenderer.render(overlay, {
          contextual: true,
          use: overlay.type === _UIOverlay.default ? 'light' : undefined
        }, {
          mergeType: 'aggressive'
        });
      }

      return _react.default.createElement(Outer, (0, _extends2.default)({}, rest, {
        "aria-hidden": hasOverlay,
        disabled: computedDisabled
      }), _react.default.createElement("div", null, _react.default.createElement(LabelWrapper, {
        hasLegend: renderedLegendWithTooltip != null
      }, renderedLegendWithTooltip, help != null ? _react.default.createElement(HelpText, null, help) : null), _react.default.createElement(_FieldsetContext.FieldsetContextProvider, {
        value: this._getContext(computedDisabled, _size)
      }, _react.default.createElement("div", null, children))), renderedOverlay);
    }
  }]);
  return UIFieldset;
}(_react.PureComponent);

exports.default = UIFieldset;
UIFieldset.propTypes = {
  children: _react.PropTypes.node,
  disabled: _react.PropTypes.bool,
  Legend: (0, _decorators.hidden)(_component.default.isRequired),
  legend: _react.PropTypes.node,
  legendId: _react.PropTypes.string,
  overlay: CustomRenderer.propType,
  tooltip: _UIFormControl.default.propTypes.tooltip,
  tooltipPlacement: _UIFormControl.default.propTypes.tooltipPlacement,
  help: _UIFormControl.default.propTypes.help,
  _size: _react.PropTypes.oneOf(Object.keys(_InputConstants.INPUT_SIZE_OPTIONS)),
  _required: _react.PropTypes.bool
};
UIFieldset.defaultProps = {
  disabled: _FieldsetContext.defaultFieldsetContext.disabled,
  Legend: FieldsetLegend,
  _required: false,
  _size: _FieldsetContext.defaultFieldsetContext.size,
  tooltipPlacement: 'top'
};
UIFieldset.displayName = 'UIFieldset';
module.exports = exports.default;